import { appendParameter } from '@SharedScripts/Utils/Url';

type initiateLoginProps = {
  successUrl?: string
  source?: string
  cancelUrl?: string
  variant?: string
}

export const getLoginUrl = ({ successUrl, source, cancelUrl, variant }: initiateLoginProps = {}) => {
  const { href, protocol, host } = window.location;
  const overrideReturnUrl = document.body.getAttribute('data-override-login-return-url');

  let returnUrl = overrideReturnUrl || successUrl || href;

  let url: string = DS.Config.BASE_HOST;

  if (DS.Config.LOGINPAGE_HOST && DS.Config.LOGINPAGE_HOST.indexOf('https://') === 0) {
    url = DS.Config.LOGINPAGE_HOST;

    if (returnUrl.indexOf('/') === 0) {
      returnUrl = protocol + '//' + host + returnUrl;
    }
  }

  if (source) {
    returnUrl = appendParameter('source', source, returnUrl);
  }

  if (document.body.classList.contains('RetailAccountFrontPage') || document.body.classList.contains('RetailAccountContentPage')) {
    url = url + '/sikkertspil/login?loginSuccessUrl=' + encodeURIComponent(returnUrl) + (cancelUrl ? '&cancelUrl=' + encodeURIComponent(cancelUrl) : '') + (variant ? '&variant=' + variant : '');
  } else {
    url = url + DS.Config.PRETTYPREFIX + '/login?loginSuccessUrl=' + encodeURIComponent(returnUrl) + (cancelUrl ? '&cancelUrl=' + encodeURIComponent(cancelUrl) : '') + (variant ? '&variant=' + variant : '');
  }

  return url;
};

export const initiateLogin = (props: initiateLoginProps = {}) => {
  const url = getLoginUrl(props);

  try {
    window.top.location.href = url;
  } catch (e) {
    // No access to window.top, Sentry log and fallback
    // ErrorLogging.capture('LoginController.openLogin: Could not redirect on window.top.location', { level: 'warning' });

    location.href = url;
  }
};

export const isLoggedIn = async (timeout = 30000): Promise<boolean> => {
  return new Promise((resolve) => {
    if (document.querySelector('body.is-logged-in')) {
      resolve(true);
    } else {

      const handleEvent = () => {
        document.removeEventListener('pageload-auth-synced', handleEvent);
        resolve(!!document.querySelector('body.is-logged-in'));
      };

      document.addEventListener('pageload-auth-synced', handleEvent);

      setTimeout(() => {
        document.removeEventListener('pageload-auth-synced', handleEvent);  // Cleanup the event listener
      }, timeout);
    }
  });
};